module.exports = __webpack_public_path__ + "static/media/ganancia.7b1b60fb.png";